import { render, staticRenderFns } from "./IconUploadSolid.vue?vue&type=template&id=d8ba8f86"
import script from "./IconUploadSolid.vue?vue&type=script&lang=js"
export * from "./IconUploadSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports